<template>
  <div>
    <div v-if="userProfile.id">
      <h3>{{ $t('set_new_password') }}</h3>
      <b-card>
        <validation-observer
          ref="securityTab"
        >
          <b-form>
            <b-row>
              <b-col
                sm="12"
                xl="6"
                class="col-xxl-4"
              >
                <b-form-group
                  :label="$t('old_Password')"
                  label-for="account-old-password"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('old_Password')"
                    vid="old_password"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="account-old-password"
                        v-model="form.old_password"
                        name="old-password"
                        :type="passwordFieldTypeOld"
                        :placeholder="$t('old_Password')"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="passwordToggleIconOld"
                          class="cursor-pointer"
                          @click="togglePasswordOld"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
                xl="6"
                class="col-xxl-4"
              >
                <b-form-group
                  label-for="account-new-password"
                  :label="$t('new_Password')"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('new_Password')"
                    vid="new_password"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="account-new-password"
                        v-model="form.password"
                        :type="passwordFieldTypeNew"
                        name="new-password"
                        :placeholder="$t('new_Password')"
                        minlength="8"
                        maxlength="16"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="passwordToggleIconNew"
                          class="cursor-pointer"
                          @click="togglePasswordNew"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
                xl="6"
                class="col-xxl-4"
              >
                <b-form-group
                  label-for="account-retype-new-password"
                  :label="$t('retype_new_password')"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('retype_new_password')"
                    vid="retype_password"
                    rules="required|confirmed:new_password"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="account-retype-new-password"
                        v-model="form.password_confirmation"
                        :type="passwordFieldTypeRetype"
                        name="retype-password"
                        :placeholder="$t('retype_new_password')"
                        minlength="8"
                        maxlength="16"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="passwordToggleIconRetype"
                          class="cursor-pointer"
                          @click="togglePasswordRetype"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                class="justify-content-end d-flex"
              >
                <b-button

                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  pill
                  variant="primary"
                  class="mt-1 mr-1 w-100 w-md-unset"
                  :disabled="userProfile.isActive == 0"
                  @click="changePassword"
                >
                  <span v-if="!pendingChangePassword">{{ $t('save_changes') }}</span>
                  <b-spinner
                    v-if="pendingChangePassword"
                    small
                    type="grow"
                  />
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card>
      <b-card>
        <validation-observer
          ref="twoFactor"
        >
          <b-form>
            <h3>{{ $t('two-factor-authentication') }}</h3>
            <p>{{ $t('Setup_two_factor_login_authentication') }}</p>
            <b-row>
              <b-col
                cols="12"
                lg="3"
                class="align-items-center d-flex"
              >
                <b-form-group>
                  <b-form-checkbox
                    id="setup"
                    v-model="userProfile.twoFactorAuth.is_active"
                    name="checkbox-1"
                  >
                    {{ $t('Setup') }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                lg="4"
              >
                <b-form-group
                  label-for="account-new-password"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('type')"
                    vid="type"
                    rules="required"
                  >
                    <v-select
                      id="type"
                      v-model="twoFactorType"
                      :disabled="!userProfile.twoFactorAuth.is_active"
                      :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                      :options="options"
                      label="label"
                      name="type"
                      :placeholder="$t('save_changes')"
                      :clearable="false"
                    >
                      <template
                        slot="option"
                        slot-scope="option"
                      >
                        <div v-if="option === 'sms'">
                          <span>{{ option.label }}</span>
                          <span style="margin: 0 4px; font-size: 12px;">({{ $t('suggested') }})</span>
                        </div>
                      </template>
                    </v-select>
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col
                v-if="twoFactorType.key === 'sms'"
                cols="12"
              >
                <DashboardAlert
                  :description="$t('two-factor-sms-warning1')"
                  :variant="'warning'"
                />
                <br>
                <DashboardAlert
                  :description="$t('two-factor-sms-warning2')"
                  :variant="'warning'"
                />
              </b-col>
              <b-col
                v-if="twoFactorType.key === 'telegram'"
                cols="12"
              >
                <b-alert
                  show
                  variant="warning"
                >
                  <b-card :title="$t('two-factor-telegram-card-title')">
                    <p>{{ $t('two-factor-telegram-card-description') }}</p>
                    <b-list-group>
                      <b-list-group-item>1. {{ $t('two-factor-telegram-card-step1') }}</b-list-group-item>
                      <b-list-group-item>2. {{ $t('two-factor-telegram-card-step2') }}</b-list-group-item>
                      <b-list-group-item>3. {{ $t('two-factor-telegram-card-step3') }}</b-list-group-item>
                      <b-list-group-item>4. {{ $t('two-factor-telegram-card-step4') }}</b-list-group-item>
                      <b-list-group-item>5. {{ $t('two-factor-telegram-card-step5') }}</b-list-group-item>
                    </b-list-group>
                  </b-card>
                </b-alert>
              </b-col>
              <b-col
                cols="12"
                class="justify-content-end d-flex"
              >
                <b-button

                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  pill
                  variant="primary"
                  class="mt-1 mr-1 w-100 w-md-unset"
                  @click="saveFactor(false)"
                >
                  <span v-if="!pendingTwoFactor"> {{ $t('save_changes') }}</span>
                  <b-spinner
                    v-else
                    small
                    type="grow"
                  />
                </b-button>

              </b-col>
            </b-row>
          </b-form>

        </validation-observer>
      </b-card>
      <securityPassword v-if="isEnableSecurityPassword" />
      <div>
        <activeSessions />
      </div>
      <!-- OTP Verification Modal -->
      <otp-verification-modal
        v-model="confirmFormModal"
        :remained-time="remained_time"
        :two-factor-type-label="twoFactorType.label"
        :pending-re-send-otp="pendingReSendOtp"
        :pending-otp="pendingOTP"
        @otp-verified="handleOTP"
        @resend-otp="saveFactor(true)"
      />
    </div>
  </div>
</template>
<script>
import {
  BInputGroupAppend,
} from 'bootstrap-vue'
import OtpVerificationModal from '@/views/theme2/components/OtpVerificationModal.vue'
import Security from '@/views/logics/profile/Security'
import securityPassword from '@/views/theme2/components/securityPassword.vue'
import DashboardAlert from '../dashboard/dashboardAlert.vue'
import activeSessions from './activeSessions.vue'

export default {
  components: {
    BInputGroupAppend,
    activeSessions,
    securityPassword,
    DashboardAlert,
    OtpVerificationModal,
  },
  mixins: [Security],

}
</script>
